import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PricingTabsSection from '../components/landingPage/PricingPage/PricingTabsSection';
import { useReveal, useCountUp } from '../components/landingPage/common/landingHooks';

const PricingPlans = () => {
    const rootRef = useRef(null);
    const location = useLocation();
    useReveal(rootRef);
    useCountUp(rootRef);

    // Scroll to a hash target (e.g. #whats-included from the Companies "See what's included" CTA).
    // The section renders after tabs/images settle, so poll briefly until it exists.
    useEffect(() => {
        const id = location.hash?.replace('#', '');
        if (!id) return;
        let tries = 0;
        const timer = setInterval(() => {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                clearInterval(timer);
            } else if (++tries > 40) clearInterval(timer); // give up after ~4s
        }, 100);
        return () => clearInterval(timer);
    }, [location.hash]);

    return (
        <div className="lp-page" ref={rootRef}>
            <PricingTabsSection />
        </div>
    );
};

export default PricingPlans;
